import { render, staticRenderFns } from "./TheInvestmentsDeals.vue?vue&type=template&id=c09dd9c4&"
import script from "./TheInvestmentsDeals.vue?vue&type=script&lang=js&"
export * from "./TheInvestmentsDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports